import React, { useEffect, useState } from "react";
import LinksComponent from "../../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../../components/Tenant/DataTableComponent/DataTableComponent";
import { toast } from "react-hot-toast";
import { useBulkUploadZoneLocMutation, useFetchAllEmployeeByCityMutation, useGetAllZoneLocMutation } from "../../../../features/tenant/zones/zonesLocApi";
import ModalComponent from "../../../../components/Tenant/ModalComponent/ModalComponent";
import { downloadSampleCSV } from "../../../../utils/downloadSampleCsv";
import { useFetchZoneLocationCsvMutation } from "../../../../features/tenant/zones/zonesApi";
import { CircleLoaderComponent } from "../../../../components/Loader/CircleLoaderComponent";
import { useBulkUploadZonePincodeMapMutation, useFetchZonePincodeApiMutation } from "../../../../features/tenant/zones/zonePincodeMapApi";

const ZonePincodeMapping = () => {
  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme.color_shades;
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [file, setFile] = useState();
  const [filters, setFilters] = useState({
    zone: "",
    state: "",
    district: "",
    branch: "",
    city: "",
    pincode: ""
  });
  const [templateData, setTemplateData] = useState([
    {
      "name": "state",
      "maxLength": 100
    },
    {
      "name": "branch_code",
      "maxLength": 50
    },
    {
      "name": "city",
      "maxLength": 100
    },
    {
      "name": "pincode",
      "maxLength": 100
    }
  ]);
  const [csvModal, setCsvModal] = useState(false);

  const [zoneLocData, setZoneLocData] = useState([]);
  const [total, setTotal] = useState(0);
  const [employeeModal, setEmployeeModal] = useState(false);
  const [employeeList, setEmployeeList] = useState([])

  const [fetchAllZoneLoc, { data: zoneLocRes, isLoading: zoneLocIsLoading, isError: zoneLocError }] =
    useFetchZonePincodeApiMutation();
  const [bulkUploadZoneLoc, { data: bulkUploadZoneLocRes,isLoading: bulkUploadZoneLocIsLoading, isError: bulkUploadZoneLocError }] =
    useBulkUploadZonePincodeMapMutation();

  const [
    fetchZoneLocationCsv,
    {
      data: fetchZoneLocationCsvData,
      isLoading: fetchZoneLocationCsvIsLoading,
      isError: fetchZoneLocationCsvIsError,
      error: fetchZoneLocationCsvError,
    },
  ] = useFetchZoneLocationCsvMutation();

  const [
    fetchEmpMapping,
    {
      data: fetchEmpMappingData,
      isLoading: fetchEmpMappingIsLoading,
      isError: fetchEmpMappingIsError,
      error: fetchEmpMappingError,
    },
  ] = useFetchAllEmployeeByCityMutation();

  useEffect(() => {
    console.log("fetchEmpMappingData", fetchEmpMappingData);
    if (fetchEmpMappingData && fetchEmpMappingData?.body) {
      setEmployeeModal(true)
      setEmployeeList(fetchEmpMappingData.body.employee)
    }
    if (fetchEmpMappingError) {
      toast.error("Error in fetching Employee City Mapping Data");
    }
  }, [fetchEmpMappingData, fetchEmpMappingError])


  const handleEmpModal = (id) => {
    fetchEmpMapping({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
       id: id
      }
    })
  }

  useEffect(() => {
    if (fetchZoneLocationCsvData && fetchZoneLocationCsvData?.body) {
      console.log("employee city mapping csv", fetchZoneLocationCsvData.body)
      if (fetchZoneLocationCsvData.body.data && fetchZoneLocationCsvData.body.data.length > 0) {
        downloadJsonAsCsv(fetchZoneLocationCsvData.body.data, "zone_locations.csv")
      }
    }
    if (fetchZoneLocationCsvError) {
      toast.error("Error in Fetching Employee CSV");
    }
  }, [fetchZoneLocationCsvData, fetchZoneLocationCsvError])

  const downloadJsonAsCsv = (
    data,
    fileName = "employee_city_mapping.csv"
  ) => {
    if (!Array.isArray(data) || data.length === 0) {
      console.error("Empty or invalid data");
      return;
    }

    // Extract headers
    const headers = Object.keys(data[0]);

    // Convert rows
    const csvRows = [
      headers.join(","), // header row
      ...data.map(row =>
        headers
          .map(field => {
            const value = row[field] ?? "";
            // escape quotes
            return `"${String(value).replace(/"/g, '""')}"`;
          })
          .join(",")
      )
    ];

    const csvString = csvRows.join("\n");

    // Create download
    const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };


  const loadZoneLoc = () => {
    fetchAllZoneLoc({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: { ...filters, limit, offset },
    });
  };

  useEffect(() => {
    loadZoneLoc();
  }, [limit, offset]);

  useEffect(() => {
    if (zoneLocRes?.body) {
      setZoneLocData(zoneLocRes.body.rows || []);
      setTotal(zoneLocRes.body.total || 0);
    }
    if (zoneLocError) toast.error("Error fetching Zone Locations");
  }, [zoneLocRes, zoneLocError]);

  useEffect(() => {
    if (bulkUploadZoneLocRes) {
      toast.success("Zone Uploaded Succesfully")
      setFile()
      setCsvModal(false)
      loadZoneLoc();
    }
    if (bulkUploadZoneLocError) toast.error("Error Uploading Zone Locations");
  }, [bulkUploadZoneLocRes, bulkUploadZoneLocError]);

  const columns = [
    { name: "SNo", cell: (row, idx) => offset + Number(idx + 1), },
    { name: "Zone", selector: (row) => row.zone || "-" },
    { name: "State", selector: (row) => row.state || "-" },
    { name: "District", selector: (row) => row.district || "-" },
    { name: "Branch Code", selector: (row) => row.branch_code || "-" },
    { name: "Branch Name", selector: (row) => row.branch_name || "-" },
    { name: "City", selector: (row) => row.city || "-" },
    { name: "Pincode", selector: (row) => row.pincode || "-" }
  ];

  const employeeColumns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      width: "80px",
    },
    {
      name: "Name",
      cell: (row) => (
        <div>
          <span className="font-medium text-gray-800">{row.name || "-"}</span>
        </div>
      ),
      width: "120px",
    },
    {
      name: "user id",
      cell: (row) => <div className="text-sm text-gray-600">{row.user_id || "-"}</div>,
      width: "120px",
    },
    {
      name: "Designation",
      cell: (row) => <div className="text-sm text-gray-600">{row.designation || "-"}</div>,
      width: "120px",
    },
    {
      name: "Mobile",
      cell: (row) => <div className="text-sm text-gray-700">{row.mobile || "-"}</div>,
      width: "150px",
    },
    {
      name: "Email",
      cell: (row) => <div className="text-sm text-gray-600">{row.email || "-"}</div>,
    }
  ];

  const handleFilterChange = (field, value) => {
    setFilters({ ...filters, [field]: value });
  };

  const clearFilters = () => {
    setFilters({
      zone: "",
      state: "",
      district: "",
      branch: "",
      city: "",
      pincode:"",
      limit: 20,
      offset: 0,
    });
    fetchAllZoneLoc({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        zone: "",
        state: "",
        district: "",
        branch: "",
        city: "",
        pincode:"",
        limit, offset
      },
    });
  };

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setLimit(newPerPage);
  };

  const handleOnChange = (e) => {
    setFile(e.target.files[0]);
  };

  function parseCSV(string) {
    const csvHeader = string
      .slice(0, string.indexOf("\n"))
      .replace(/\s/g, "")
      .split(",");

    const csvRows = string.slice(string.indexOf("\n") + 1).split(/\r?\n/);

    // console.log("csvRows: ", csvRows.length, csvRows);

    const array = csvRows
      .map((row) => {
        const values = [];
        let insideQuotes = false;
        let currentField = "";

        for (let char of row) {
          if (char === "," && !insideQuotes) {
            values.push(currentField.trim());
            currentField = "";
          } else if (char === '"') {
            insideQuotes = !insideQuotes;
          } else {
            currentField += char;
          }
        }

        values.push(currentField.trim());
        return values;
      })
      .filter((values) => values.length === csvHeader.length)
      .map((values) => {
        const obj = csvHeader.reduce((object, header, index) => {
          object[header] = values[index].trim();
          return object;
        }, {});
        return obj;
      });

    return array;
  }

  const handleOnSubmit = (e) => {
    if (e) {
      e.preventDefault();
    }

    if (!file) {
      toast.error("Please select a file");
      return;
    }
    const fileReader = new FileReader();
    if (file) {
      fileReader.onload = function (event) {
        const text = event.target.result;
        let datas = parseCSV(text);
        console.log("parsed csv data", datas);

        bulkUploadZoneLoc({
          token: sessionStorage.getItem("access_token"),
          tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
          body: {
            rows: datas
          }
        });

      };

      fileReader.readAsText(file);
    }
  };

  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full">
          {
            (fetchZoneLocationCsvIsLoading ||
              fetchEmpMappingIsLoading ||
              zoneLocIsLoading ||
              bulkUploadZoneLocIsLoading) &&
            <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-white/60 backdrop-blur-sm">
              <CircleLoaderComponent />
            </div>
          }
          {/* Header */}
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Zone Pincode Mapping
            <LinksComponent />
          </div>

          <div className="p-3 ">
            <div class="flex justify-between">
              <div className="flex justify-between items-start">
                <div className="flex gap-2">
                  <button
                    className="btn btn-outline-primary clear-both float-right  mb-2 mr-3"
                    onClick={() => {
                      setCsvModal(true);
                    }}
                  >
                    Add Zone Locations CSV
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Filters Section */}
          <div className="p-3">
            <div className="p-3 w-full bg-white shadow rounded-lg">
              <div className="border-b border-gray-300 bg-gray-50 rounded-t-lg p-3">
                <div className="flex space-x-2 justify-end">

                  {[
                    { key: "zone", label: "Zone" },
                    { key: "state", label: "State" },
                    { key: "district", label: "District" },
                    { key: "branch", label: "Branch Code" },
                    { key: "city", label: "City" },
                    { key: "pincode", label: "Pincode" },
                  ].map((item) => (
                    <div className="w-52 h-10">
                      <div className="relative searchin">
                        <label class="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                          {item.label}
                        </label>
                        <input
                          className="w-full px-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                          name={item.label}
                          //   value={request.status}
                          value={filters[item.key]}
                          onChange={(e) => handleFilterChange(item.key, e.target.value)}
                        />
                      </div>
                    </div>

                  ))}

                  <div className="flex flex-row gap-2 h-10 mt-6">
                    <button
                      className="btn btn-outline-primary p-2"
                      onClick={loadZoneLoc}
                    >
                      Search
                    </button>

                    <button
                      className="btn btn-outline-primary p-2"
                      onClick={clearFilters}
                    >
                      Clear
                    </button>
                  </div>
                </div>
              </div>

              {/* Table */}
              <DataTableComponent
                keyField="id"
                columns={columns}
                data={zoneLocData}
                totalRows={total}
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              />
            </div>
          </div>
        </div>
      </div>

      {employeeModal && (
        <ModalComponent
          show={employeeModal}
          setShow={() => {
            setEmployeeModal(false);
            setEmployeeList([]);
          }}
          size="4xl"
        >
          <div className="p-6 flex flex-col gap-4">

            {/* Header */}
            <div className="flex justify-between items-center border-b pb-3">
              <h2 className="text-lg font-semibold text-gray-800">
                Employee List
              </h2>
            </div>

            {/* Table */}
            <div className="overflow-y-auto max-h-[60vh] border rounded">
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={employeeColumns}
                data={employeeList}
                totalRows={
                  employeeList.length || 0
                }
                pagination={false}
              />
            </div>

            {/* Footer */}
            <div className="flex justify-end gap-3 pt-3 border-t">
              <button
                onClick={() => {
                  setEmployeeModal(false);
                  setEmployeeList([]);
                }}
                className="px-4 py-2 text-sm text-gray-700 border rounded hover:bg-gray-100"
              >
                Close
              </button>
            </div>

          </div>
        </ModalComponent>

      )}

      {csvModal && (
        <ModalComponent show={csvModal} setShow={setCsvModal} size="md">
          <div className="w-full p-4">
            {templateData && templateData?.length > 0 && (
              <div className="flex justify-center mt-3 ">
                <button
                  type="submit"
                  className="mb-3 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                  onClick={() => downloadSampleCSV(templateData)}
                >
                  Sample Csv Download
                </button>
              </div>
            )}
            <div className="w-full m-auto  justify-center ">
              <div className="flex items-center justify-center w-full">
                <label
                  for="dropzone-file"
                  className="flex flex-col items-center justify-center w-full h-20 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100  "
                >
                  <div className="flex flex-col items-center justify-center ">
                    <svg
                      aria-hidden="true"
                      className="w-20 h-20 mb-3 text-gray-400 mt-2"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        stroke-linecap="round"
                        strokeLinejoin="round"
                        stroke-width="2"
                        d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                      ></path>
                    </svg>
                    <p className="mb-2 text-sm text-gray-500 text-center">
                      <span className="font-semibold">Choose CSV file</span>
                      <div>Click to upload or drag and drop</div>
                    </p>
                  </div>
                  <input
                    id="dropzone-file"
                    type="file"
                    className="hidden"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    onChange={handleOnChange}
                  />
                </label>
              </div>
            </div>

            {templateData && templateData?.length > 0 ? (
              <div className="flex justify-center mt-3">
                <button
                  type="submit"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                  onClick={(e) => handleOnSubmit()}
                >
                  Add
                </button>
              </div>
            ) : (
              <div className="text-red-500 rounded-lg text-sm px-5 py-2.5 text-center ">
                No Template Found !
              </div>
            )}
          </div>
        </ModalComponent>
      )}
    </>
  );
};

export default ZonePincodeMapping;
